import { useQuery } from 'react-query';
import { http } from '../api/http';
import { Home } from '../types/home';

export function useGetMyHomes() {
  return useQuery<Home[], any>('get_my_homes', http.getMyHomes, { cacheTime: 0 });
}
